import React from 'react';
import { cn } from '@/lib/utils';

const cardVariants = {
  default: 'ui-card card-shell border border-border-soft bg-bg-surface shadow-card rounded-card',
  premium: 'ui-card ui-card--premium card-shell border border-border-soft bg-bg-surface shadow-card rounded-card',
};

export function Card({ className = '', variant = 'default', children = null, ...props } = {}) {
  return (
    <div className={cn(cardVariants[variant] || cardVariants.default, className)} {...props}>
      {children}
    </div>
  );
}

export function CardHeader({ className = '', children = null, ...props } = {}) {
  return (
    <div
      className={cn('flex flex-col space-y-1.5 p-4 md:p-6', className)}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardTitle({ className = '', children = null, ...props } = {}) {
  return (
    <h3
      className={cn('text-xl md:text-2xl font-semibold leading-none tracking-tight font-body', className)}
      {...props}
    >
      {children}
    </h3>
  );
}

export function CardContent({ className = '', children = null, responsive = false, ...props } = {}) {
  return (
    <div
      className={cn('p-4 md:p-6 pt-0', responsive && 'card-content--responsive', className)}
      {...props}
    >
      {children}
    </div>
  );
}
